export type EquipmentGroupRow = {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  title?: string;
  procedureInstanceId: string;
  propelOrgId: string;
};

export class EquipmentGroup {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  title: string;
  procedureInstanceId: string;
  propelOrgId: string;

  constructor(params: EquipmentGroupRow) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.title = params.title || '';
    this.procedureInstanceId = params.procedureInstanceId;
    this.propelOrgId = params.propelOrgId;
  }
}
